<template>
  <div class="user-cardreader">
    <b-alert
      :variant="alertvariant"
      :show="dismissCountDown"
      dismissible
      @dismissed="dismissCountDown = 0"
      @dismiss-count-down="countDownChanged"
    >
      <p>{{ alerttxt }}</p>
      <b-progress
        :variant="alertvariant"
        :max="5"
        :value="dismissCountDown"
        height="4px"
      >
      </b-progress>
    </b-alert>
    <v-select
      label="docNo"
      ref="OrderSearchSelect"
      v-model="selected"
      placeholder="Recuperar documento..."
      @input="onSubmit"
      :filterable="false"
      :options="options"
      @search="onSearch"
    >
      <template slot="no-options"> Recuperar documento... </template>
      <template slot="option" slot-scope="option">
        <div>
          {{ option.docNo }} - {{ option.postingDate.substring(0, 10) }} -
          {{ option.custNo }} - {{ option.custAlias }}:
          {{ parseFloat(option.remainAmount).toFixed(2) + " €" }}
        </div>
      </template>
      <template slot="selected-option" scope="option">
        <div>
          {{ option.docNo }}
        </div>
      </template>
    </v-select>
  </div>
</template>

<script>
import mixin from "@/components/mixin.js";
import _ from "lodash";

export default {
  mixins: [mixin],
  name: "RecoverSalesOrder",
  data() {
    return {
      form: {
        OrderId: "",
      },
      alertvariant: "warning",
      alerttxt: "",
      dismissCountDown: 0,
      options: [],
      selected: null,
    };
  },
  methods: {
    onSearch(search, loading) {
      if (search.length > 3) {
        this.debouncedSearch(search, loading);
      }
    },      
    debouncedSearch: _.debounce(function (search, loading) {
      this.search(search, loading);
    }, 300),
    search(search, loading) {
      loading(true);
      let SearchReq = {
        SearchStr: search,
        DocType: this.$store.state.curDocType
      };
      
      switch (this.$store.state.curDocType) {
        case 4:
          this.axios
            .post(
              this.ApiBaseUrl + "PendingInvoice/SearchPendingInvoice",
              JSON.stringify(SearchReq.SearchStr),
              { headers: { "Content-Type": "application/json" } }
            )
            .then((response) => {
              this.options = response.data;
              loading(false);
            });
          break;
        case 9:
          this.axios
            .post(
              this.ApiBaseUrl + "History/SearchHistoryInvoice",
              JSON.stringify(SearchReq.SearchStr),
              { headers: { "Content-Type": "application/json" } }
            )
            .then((response) => {
              this.options = response.data;
              loading(false);
            });
          break;

        default:
          //Buscar pedidos o presupuestos
          this.axios
            .post(
              this.ApiBaseUrl + "Sales/SearchSalesOrders",
              JSON.stringify(SearchReq),
              { headers: { "Content-Type": "application/json" } }
            )
            .then((response) => {
              this.options = response.data;
              loading(false);
            });
          break;
      }
    },    
    onSubmit() {
      let selected = this.selected;
      if (selected != null && selected != undefined)
        if (selected.docNo != null && selected.docNo != undefined) {
          switch (this.$store.state.curDocType) {
            case 4:
              this.InvoicePayment(selected);
              break;
            case 9:
              this.SetHistoricDocument(selected);
              break;
            default:
              this.RecoverSale(selected.docNo);
              break;
          }
        }
      this.$refs.OrderSearchSelect.clearSelection();
      this.selected = null;
    },
    InvoicePayment(selected) {
      this.$store.commit("resetCart");
      let tempitem = {
        linetotal: Math.abs(selected.remainAmount),
      };
      var search = selected.custNo;
      this.axios
        .post(this.ApiBaseUrl + "CustSearch/GetCust", JSON.stringify(search), {
          headers: { "Content-Type": "application/json" },
        })
        .then((CustRes) => {
          this.$store.commit("setCust", CustRes.data[0]);
        });
      var urlLines = selected.docType == 2 ? 'PendingInvoice/invoiceLines' : 'PendingInvoice/crMemoLines'
      this.axios
        .post(this.ApiBaseUrl + urlLines, JSON.stringify(selected.docNo), {
          headers: { "Content-Type": "application/json" },
        })
        .then((LinesRes) => {
          LinesRes.data.forEach(salesline => {
              this.$store.commit('addItem', salesline)                             
          });
        })
        .finally(() => {
          this.$router.push("payment");
        });
      this.$store.commit("setcurOrder", selected.docNo);
      //this.$store.commit("addItem", tempitem); //esta linea era para cargar el total cuando no se recuperaban las lineas, ahora viene de las lineas de la factura
      this.$store.commit("setpaymentDocType", selected.docType);
      //this.$router.push("payment"); //se mueve al final del axios a PendingInvoice/invoiceLines para que el total este disponible
    },
    SetHistoricDocument(selected) {
      this.$store.commit("resetCart");
      this.$store.commit("setcurOrder", selected.docNo);      
      this.$store.commit("setpaymentDocType", selected.docType);
      this.$store.commit("setprintdoc", selected.docNo);      
      this.$router.push("payment");
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    onReset(evt) {
      evt.preventDefault();
      /* Reset our form values */
      this.form.OrderId = "";
      /* Trick to reset/clear native browser form validation state */
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    }
  }
}

</script>